import { ajax } from 'rxjs/ajax';
import { catchError } from 'rxjs/operators';
import { addCsrfTokenHeader, getCsrfToken } from '../csrf';
var SEARCHABILITY_URL = '/candidate/profile/editor/api/v1/searchability';
export var patchSearchability = function (candidateSearchable) {
    var csrfToken = getCsrfToken();
    var searchabilityUrl = global.TEST_ENV === '1'
        ? "https://".concat(window.location.host).concat(SEARCHABILITY_URL)
        : SEARCHABILITY_URL;
    var headers = addCsrfTokenHeader(csrfToken, {
        'Content-Type': 'application/json',
    });
    var request$ = ajax({
        url: searchabilityUrl,
        method: 'PATCH',
        headers: headers,
        body: { candidateSearchable: candidateSearchable },
    }).pipe(catchError(function (error) {
        return Promise.reject(error);
    }));
    return request$.toPromise();
};
//# sourceMappingURL=SearchabilityService.js.map